module.exports = __webpack_public_path__ + "images/btn-socialsign-sc.png?2c1f4";